<div [formGroup]="form">
  <div class="flex items-center" mat-dialog-title>
    <h2 class="headline m-0 flex-auto">{{ title }}</h2>
    <button class="text-secondary" mat-dialog-close type="button" mat-icon-button>
      <ic-icon [icon]="icClose"></ic-icon>
    </button>
  </div>

  <mat-dialog-content>
    <ng-container *ngIf="isAssign">
      <p class="mb-4">
        Sélectionnez l'acteur « Supervision métier » par défaut pour
        <strong>{{ data.node.label }}</strong>
        &ngsp;
        <ng-container *ngIf="data.establishment">(établissement {{ data.establishment.label }})</ng-container>
        .
      </p>
      <base-form-input
        label="Acteur Supervision métier"
        controlName="contact"
        type="autocomplete"
        [items$]="contacts$"
        displayProperty="fullName"
        (autocompleteChange)="autocompleteContacts($event)"
      ></base-form-input>
    </ng-container>

    <p class="mb-3">
      <ng-container *ngIf="isAssign">
        Vous venez de modifier le contact par défaut du générique
        <strong>{{ data.node.label }}</strong>
        . Comment souhaitez-vous appliquer la modification ?
      </ng-container>
      <ng-container *ngIf="!isAssign">
        Vous venez de retirer le contact par défaut du générique
        <strong>{{ data.node.label }}</strong>
        . Comment souhaitez-vous appliquer la modification ?
      </ng-container>
    </p>

    <mat-radio-group formControlName="propagationMode" class="flex flex-col gap-3 propagation-options">
      <mat-radio-button [value]="DefaultSupervisionPropagationModeEnum.ALL">
        <span class="block font-medium">
          Remplacer le contact sur tou(te)s les {{ data.node.label }}, y compris ceux qui ont été modifiés.
        </span>
        <span class="block text-secondary text-xs">
          Les données de cette catégorie dont l'acteur a été modifié manuellement seront également remplacées.
        </span>
      </mat-radio-button>
      <mat-radio-button [value]="DefaultSupervisionPropagationModeEnum.ONLY_DEFAULT">
        <span class="block font-medium">
          Remplacer le contact sur tou(te)s les {{ data.node.label }} définis par défaut.
        </span>
        <span class="block text-secondary text-xs">
          Les données de cette catégorie modifiées manuellement conservent leur acteur actuel.
        </span>
      </mat-radio-button>
    </mat-radio-group>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-button mat-dialog-close type="button">ANNULER</button>
    <button mat-raised-button color="primary" type="button" [disabled]="loading" (click)="save()">VALIDER</button>
  </mat-dialog-actions>
</div>
